import { Box, CircularProgress } from "@mui/material"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { useCallback, useId } from "react"

export default function InputSelect({
	label,
	description,
	value,
	setValue,
	optionsId,
	optionsLabel,
	onChange,
	onBlur,
	sx,
	disabled = false,
	options = [],
	fullWidth = true,
	required = false,
	textNoData = "No hay opciones",
	loading = false,
}) {
	const id = useId()

	const handleChange = useCallback(
		(event) => {
			if (typeof onChange === "function") {
				onChange(event)
			} else if (typeof setValue === "function") {
				setValue(event.target.value)
			}
		},
		[onChange, setValue]
	)

	const optionIdControl = useCallback(
		(option) => (optionsId ? option?.[optionsId] : option),
		[optionsId]
	)

	const optionLabelControl = useCallback(
		(option) => (optionsLabel ? option?.[optionsLabel] : option),
		[optionsLabel]
	)

	return (
		<FormControl
			fullWidth={fullWidth}
			disabled={disabled}
			required={required}
			sx={{ minWidth: 200, ...sx }}
		>
			<InputLabel id={`label-${id}`}>{label}</InputLabel>

			<Select
				id={id}
				labelId={`label-${id}`}
				label={label}
				value={value ?? ""}
				onChange={handleChange}
				onBlur={onBlur}
				// displayEmpty
				MenuProps={{
					PaperProps: { style: { maxHeight: 300 } },
				}}
			>
				{loading ? (
					<MenuItem disabled>
						<Box display="flex" alignItems="center" gap={1}>
							<CircularProgress size={20} />
							Cargando...
						</Box>
					</MenuItem>
				) : options.length === 0 ? (
					<MenuItem disabled>{textNoData}</MenuItem>
				) : (
					options.map((option, index) => (
						<MenuItem
							key={`${id}-${index}`}
							title={description ? option?.[description] : ""}
							value={optionIdControl(option)}
						>
							{optionLabelControl(option)}
						</MenuItem>
					))
				)}
			</Select>
		</FormControl>
	)
}

export const NotItem = ({ options, textNoData = "No hay opciones" }) => {
	if (options.length) return null

	return (
		<MenuItem key={"noOptions"} disabled value={null}>
			{textNoData}
		</MenuItem>
	)
}
